import { useDispatch } from "react-redux";
import { TableFooter, TablePagination, TableRow } from "@material-ui/core";
import { setPage, setRowsPerPage } from "../../redux/actions/paginationActions";
import { TablePaginationAct } from "./TablePaginationAct";

interface Props {
  rowsPerPage?: number;
  page?: number;
  count: number;
  onChangePage?: (event: any, newPage: number) => void;
  onChangeRowsPerPage?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const CustomizedTableFooter = (props: Props) => {
  const { rowsPerPage, page, count, onChangePage, onChangeRowsPerPage } = props;
  const dispatch = useDispatch();

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (onChangePage) {
      onChangePage(event, newPage);
    } else {
      dispatch(setPage(newPage));
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (onChangeRowsPerPage) {
      onChangeRowsPerPage(event);
    } else {
      dispatch(setRowsPerPage(parseInt(event.target.value, 10)));
      dispatch(setPage(0));
    }
  };

  return (
    <TableFooter style={{ width: "100%", padding: 0, margin: 0 }}>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={[5]}
          colSpan={9}
          count={count}
          rowsPerPage={rowsPerPage ? rowsPerPage : 6}
          page={page ? page : 0}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationAct}
        />
      </TableRow>
    </TableFooter>
  );
};
